import { render } from "./StockCalculatedLocationBox.vue?vue&type=template&id=b12d9f34"
import script from "./StockCalculatedLocationBox.vue?vue&type=script&lang=js"
export * from "./StockCalculatedLocationBox.vue?vue&type=script&lang=js"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__